BaseModel = require './base_model.coffee'

class global.HubspotSetting extends BaseModel
  @ATTRIBUTES = {
    id: {}
    create_webhook: {}
    triggers: { default: { on_created: false, status: ['connected'], stages: [] }, type: Object }
    use_carousel: { default: true }
    access_token: {}
    properties_matching: { default: [], type: Array }
    stages_matching: { default: [], type: Object }
    metadata: { default: { pipeline_id: null, lifecycles: [] } }
    pipeline: {}
    stage: {}
    mark_as: { default: 'update_deal_lost' }
  }



// WEBPACK FOOTER //
// ./src/models/hubspot_setting.coffee